// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3076":"f798e11c","9951":"1118b803"}[chunkId] + ".chunk.css";
};